export type TabPaneProps = {
    tabKey: React.Key; // Unique key per tab
    tab: React.ReactNode;
    children: React.ReactNode;
    className?: string;
    disabled?: boolean;
};
function TabPane({ children }: TabPaneProps) {
    return <>{children}</>;
}

export default TabPane;
